import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

type ImagePasteUploadOptions = {
  onPasteImages: (files: File[]) => void;
};

export const ImagePasteUpload = Extension.create<ImagePasteUploadOptions>({
  name: "imagePasteUpload",

  addOptions() {
    return {
      onPasteImages: async () => {
        throw new Error("uploadImage is not configured");
      },
    };
  },

  addProseMirrorPlugins() {
    const { options } = this;

    return [
      new Plugin({
        key: new PluginKey("imagePasteUpload"),
        props: {
          handlePaste(view, event) {
            const items = event.clipboardData?.items;

            if (!items) return false;

            const files: File[] = [];

            for (const item of items) {
              if (item.type.startsWith("image/")) {
                const file = item.getAsFile();
                if (file) files.push(file);
              }
            }

            if (files.length > 0) {
              event.preventDefault();
              options.onPasteImages(files);
              return true;
            }

            return false;
          },
        },
      }),
    ];
  },
});
